// SEDE 派件费的统一计算入口
// - attachSedeAddls：把每个 sr 在静态条件下还可能命中的 SEDE 候选项写到 parcelsFeeFormulas.sedeAddls
// - computeSedeFee：运行时按当前 jyoCarrier 决定 CVS 是否参与，并按互斥重量档取最低 saFee

function isWeightBand (item) {
  return typeof item.saTarget === 'string' && /^<=\d+g$/.test(item.saTarget)
}

export function attachSedeAddls (prepareModel) {
  if (!prepareModel || !Array.isArray(prepareModel.shippingRates)) return
  const shippingAddls = Array.isArray(prepareModel.shippingAddls) ? prepareModel.shippingAddls : []
  const hasWhseSuspendAt = Array.isArray(prepareModel.parcels) &&
    prepareModel.parcels.some(p => p && p.extraInfo && p.extraInfo.whseSuspendAt)

  prepareModel.shippingRates.forEach(sr => {
    if (!sr || !sr.parcelsFeeFormulas) return
    sr.parcelsFeeFormulas.sedeAddls = []

    if (sr.transport !== 'se') return
    if (sr.srLabel && sr.srLabel.startsWith('TBPDD')) return
    if (Number(sr.srTwAddrid) > 0) return
    if (sr.srLabel === 'CB1688') return
    if (hasWhseSuspendAt) return

    // 重量卡只折抵基础运费，SEDE 派件费门槛仍按折抵前计费重量判断。
    const chargeWeight = sr.jyorderCardwt
      ? (sr.jyorderCardwt.chgWeightOrig ?? sr.parcelsFeeFormulas.srChgWeightOrig)
      : sr.parcelsFeeFormulas.srChgWeight
    const parsedChargeWeight = Number(chargeWeight)
    const srChgWeight = Number.isFinite(parsedChargeWeight)
      ? parsedChargeWeight
      : Number(sr.parcelsFeeFormulas.srChgWeight) || 0
    sr.parcelsFeeFormulas.sedeAddls = shippingAddls
      .filter(item => {
        if (item.saLabel !== 'SEDE') return false
        if (srChgWeight > Number(item.saMaxWeight)) return false
        if (item.saTarget === 'MG' && sr.srSite !== 'MG') return false
        return true
      })
      .map(item => ({
        saTarget: item.saTarget,
        saFee: Number(item.saFee),
      }))
  })
}

export function computeSedeFee (sedeAddls, jyoCarrier) {
  if (!Array.isArray(sedeAddls) || sedeAddls.length === 0) return 0
  const availableAddls = sedeAddls.filter(item => item.saTarget !== 'CVS' || jyoCarrier === '711')
  const hasZeroWeightBand = availableAddls.some(item => item.saTarget === '<=0g')
  let min = 0
  availableAddls.forEach(item => {
    // <=0g 与 <=4500g 是互斥重量档；0g 时仍保留 CVS、MG 等专属规则参与比价。
    if (hasZeroWeightBand && isWeightBand(item) && item.saTarget !== '<=0g') return
    if (min === 0 || item.saFee < min) {
      min = item.saFee
    }
  })
  return min
}
